export default __webpack_public_path__ + "static/media/DSC_0690.7a6bbc68.JPG";